module.exports = __webpack_public_path__ + "static/icon-quota.d7044ce1.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/icon-quota.png
// module id = 985
// module chunks = 2